import React, { useEffect, useState } from 'react';
import { Table } from 'reactstrap';
import { InputTime, Switch, SaveOrCancel } from 'components';
import { UpdateSchedule, GetScheduleService } from 'services';
import "./schedule.scss";
export function Schedule({ idContact, trigger , close }) {

  let alterations = [];

  const [fullSchedule, setFullSchedule] = useState();

  useEffect(() => {
    GetScheduleService(idContact).then((schedule) => {
      setFullSchedule(schedule.schedules);
    })
  }, [idContact]);

  useEffect(() => {
    // eslint-disable-next-line
    alterations = [];
  });

  const detectElement = (object, element) => {
    const type = element.identifier;

    const atributes = {
      timeStart: () => object.timeStart = element.time,
      timeEnd: () => object.timeEnd = element.time,
      active: () => object.enabled = element.time
    }
    atributes[type]();
  }

  const updateSchedule = (alterations) => {
    alterations.forEach(element => {
      detectElement(fullSchedule[element.key], element);
    });

    sendSchedule(idContact, fullSchedule)
    alterations = [];
  }

  const sendSchedule = (id, listSchedule) => {
    UpdateSchedule(id, { listUpdated: listSchedule });
  }

  const daysWeek = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sab", "Dom"];

  const addInterations = (time) => {
    alterations.push(time);
  }

  const selectRenderComponent = (value, key, col) => {

    const type = typeof value;

    const components = {
      string: ()=> col === 2 ?
        <InputTime time={value} type={"timeStart"} extractTime={addInterations} row={key}/> :
        <InputTime time={value} type={"timeEnd"} extractTime={addInterations} row={key}/>,
       boolean: ()=> <Switch id={key} active={value} extractTime={addInterations} type={"active"} row={key}/>,
       number: ()=> daysWeek[key]
     }

    return components[type]();
  }

  const renderRowComponents = (dayAtributes, id) => {
    return Object.values(dayAtributes).map((attr, col) => {
      return (
        <td>{selectRenderComponent(attr, id, col)}</td>
      );
    })
  }

  const populateRowTime = (content) => {
    if (content) {
      return content.map((day, key) => {
        return (
          <tr>
            {renderRowComponents(day, key)}
          </tr>
        );
      })
    }
  }

  const saveSchedule = ()=> {
    updateSchedule(alterations)
    trigger();
  }

  return (
    <div className="schedule">
      <Table striped>
        <thead>
          <tr>
            <th>
              Dia da Semana
            </th>
            <th>
              Ativo
            </th>
            <th>
              Horário Início
            </th>
            <th>
              Horário Fim
            </th>
          </tr>
        </thead>
        <tbody>
          {populateRowTime(fullSchedule)}
        </tbody>
      </Table>
      <SaveOrCancel actionSave={() => saveSchedule() } close={close} />
    </div>
  );
}
